angular.module('ui.loadingShadow', [])

    .service("loadingShadowService", function ($compile, $rootScope) {
        var _this = this;
        var scope;
        var el;

        _this.show = function () {
            if (scope) {
                return;
            }
            scope = $rootScope.$new(true);
            el = $compile("<loading-shadow></loading-shadow>")(scope);
            angular.element("body").append(el);
        };

        _this.hide = function () {
            if (scope) {
                scope.$destroy();
                el.remove();
                scope = null;
                el = null;
            }
        };

        return _this;
    })

    .directive('loadingShadow', function () {
        return {
            restrict: "E",
            template: '<div class="loading-shadow">' +
                '<div class="loading-shadow-msg-container">' +
                '<div class="loading-shadow-spinner-container"><span om-spinner size="1.2em" style="margin-left:0.4em;margin-top: 1em;position: absolute;text-shadow: none;"></span></div>' +
                '<div class="loading-shadow-text">{{"Sorry, server is not responding"|translate}}</div>' +
                '<div class="loading-shadow-subtext">{{"We will bring you online as soon as possible..."|translate}}</div>' +
                '</div>' +
                '</div>',
            controller: "LoadingShadowController",
            scope: {}
        };
    })

    .controller('LoadingShadowController', function LoadingShadowController($scope) {

    })

;
